import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import {
  isBottomNavVisible,
  normalizePathname,
  type BottomNavTabPath,
} from '@/lib/bottomNavVisibility';

const navItems: {
  path: BottomNavTabPath;
  icon: string;
  activeIcon: string;
  label: string;
}[] = [
  { path: '/', icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill', label: 'Home' },
  { path: '/team', icon: 'ri-bar-chart-2-line', activeIcon: 'ri-bar-chart-2-fill', label: 'Team' },
  { path: '/orders', icon: 'ri-file-list-3-line', activeIcon: 'ri-file-list-3-fill', label: 'Ticket' },
  { path: '/me', icon: 'ri-user-3-line', activeIcon: 'ri-user-3-fill', label: 'Me' },
];

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const pathname = normalizePathname(location.pathname);

  if (!isBottomNavVisible(isAuthenticated, pathname)) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-30 bg-white border-t border-gray-200 flex items-center justify-around px-2"
      style={{ height: 60, paddingBottom: 'env(safe-area-inset-bottom)', maxWidth: 480, margin: '0 auto' }}
    >
      {navItems.map((item) => {
        const isActive = pathname === item.path;
        return (
          <button
            key={item.path}
            type="button"
            onClick={() => navigate(item.path)}
            className="flex flex-col items-center justify-center gap-1 cursor-pointer flex-1 py-1.5 relative"
          >
            {isActive && (
              <span className="absolute top-1 left-1/2 -translate-x-1/2 w-5 h-0.5 rounded-full bg-green-600" />
            )}
            <div className="w-5 h-5 flex items-center justify-center">
              <i
                className={`${isActive ? item.activeIcon : item.icon} text-lg ${
                  isActive ? 'text-green-600' : 'text-gray-400'
                }`}
              />
            </div>
            <span className={`text-[9px] font-medium ${isActive ? 'text-green-600' : 'text-gray-400'}`}>
              {item.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
